import MainApi from '../../../api/MainApi'

export const ConfigApi = {
    config: () =>
        MainApi.get('/api/v1/config', { params: { is_web: true } }).catch((error) => console.log(error)),
}
